import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Utilisation rate',
  graphDotName: 'Utilisation rate',
});
